import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoEmail from 'eco-design/elements/eco-email';
import { generalKeys } from '../../../../config/pageConfig';
import styles from './index.module.scss';
import useEmailConfig from './config';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';

const Subscribe: React.FC = () => {
    const { gloproductlist } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('Subscribe');
    const emailConfig = useEmailConfig(locale);

    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKeys[0].key });

    const termsTran = {
        us: 'I consent to the <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        ca: 'I consent to the <a href="https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        eu: 'I consent to the <a href="https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        nl: 'Ik ga akkoord met de <a href="https://account.ecoflow.com/agreement/nl-nl/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Gebruiksvoorwaarden</a> en het <a href="https://account.ecoflow.com/agreement/nl-nl/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacybeleid</a>.',
        uk: 'I consent to the <a href="https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        de: 'Ich stimme den <a href="https://account.ecoflow.com/agreement/de-de/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen </a> und der <a href="https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer"> Datenschutzrichtlinie</a> zu.',
        fr: 'J\'accepte les <a href="https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Conditions d\'utilisation</a> et la <a href="https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Politique de confidentialité</a>.',
        it: 'Acconsento ai <a href="https://account.ecoflow.com/agreement/it-it/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Termini di utilizzo</a> e <a href="https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">all’Informativa sulla privacy</a>.',
        es: 'Acepto los <a href="https://account.ecoflow.com/agreement/es-es/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Términos de uso</a>  y la  <a href="https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Política de privacidad</a>.',
    };

    const termsHtml = termsTran[locale] || termsTran['us'];

    return (
        <div className={`${styles.Subscribe} GtmModuleData-section`} data-section-id={'Subscribe'}>
            <EcoSectionCommon title={t('title')} />
            <div className="trail-layout box">
                <div className="content-box">
                    <div className="input-box">
                        {['us', 'ca'].includes(locale) ? (
                            <div className="title">{t('subTitle')}</div>
                        ) : (
                            <div className="title-box">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1756781560790-kcu7r8-compressed-image%205156040.png" />
                                <div className="subTitle-box">
                                    <div className="subTitle1">{t('subTitle1')}</div>
                                    <div className="subTitle2">{t('subTitle2')}</div>
                                </div>
                            </div>
                        )}

                        <EcoEmail
                            tipsObj={{
                                placeholder: t('placeholder'),
                                successTips: t('successTips'),
                                tipsEmpty: t('tipsEmpty'),
                                tipsTypeError: t('tipsTypeError'),
                                tipsCheck: t('tipsCheck'),
                            }}
                            source={emailConfig.source}
                            contactListId={[emailConfig.contactListId]}
                            defaultTermsCheck={['us', 'ca'].includes(locale)}
                            fields={emailConfig.fields}
                            termsHtml={termsHtml}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: 'Subscribe',
                                product_name: productMsg?.name || 'none',
                            }}
                            subscribeData={{
                                sector_name: t('title'),
                                entry_position: 2,
                            }}
                        />
                    </div>
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1753672238094/subscribe-pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1753672238380/subscribe-pad.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1753672237964/subscribe-h5.jpg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Subscribe;
